import {formatTime} from '@/util/date-utils';
import PropTypes from 'prop-types';
import React from 'react';

class ChartAxisTickHourMinutesFromTimestamp extends React.PureComponent {
    static propTypes = {
        x: PropTypes.number,
        y: PropTypes.number,
        payload: PropTypes.object,
        textAnchor: PropTypes.string,
    };

    render() {
        const {
            x, y, payload,
        } = this.props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={14} textAnchor={this.props.textAnchor || 'end'} fill="#fff" >
                    {formatTime(payload.value)}
                </text>
            </g>
        );
    }
}

export { ChartAxisTickHourMinutesFromTimestamp };
